import CategoriesContainer from './CategoriesContainer';

export default CategoriesContainer;
